import { Injectable } from '@angular/core';
import { TranscribeErrorHandler } from '@xmedical/transcribe';
import * as Sentry from '@sentry/angular';

@Injectable({ providedIn: 'root' })
export class SentryTranscribeErrorHandler implements TranscribeErrorHandler {
  error(message: string, error?: unknown): void {
    console.error(`[Transcribe] ${message}`, error);
    Sentry.captureException(error ?? new Error(message), {
      tags: { source: 'transcribe' },
    });
  }

  warn(message: string): void {
    console.warn(`[Transcribe] ${message}`);
    Sentry.captureMessage(`[Transcribe] ${message}`, 'warning');
  }

  info(message: string): void {
    // Info messages stay console-only — Sentry charges per event
    console.log(`[Transcribe] ${message}`);
  }
}
